import Intercom from 'images/intercom.svg';
import IntercomTrigger from 'images/intercom-trigger.svg';
import React, { FC } from 'react';
import { useIntercomShow } from 'components/intercom/hooks/use-intercom-show';
import classNames from 'classnames';

type PropsType = {
  additionalClassName?: string;
};

const IntercomTriggerIcon: FC<PropsType> = ({
  additionalClassName,
}) => {
  const intercomShow = useIntercomShow();

  const handlerIntercomToggle = () => {
    intercomShow();
  };

  return (
    <div
      className={classNames('cursor-pointer', additionalClassName)}
      onClick={handlerIntercomToggle}
      role="presentation"
    >
      <div>
        <img src={Intercom} className="w-30" />
      </div>
      <img src={IntercomTrigger} className="ml-12p mt-4p" />
    </div>
  );
};

export { IntercomTriggerIcon };
